import React from "react";
import ActivityDashboard from "./ActivityDashboard";
import ActivityTimeline from "./ActivityTimeline";
import ActivityLogTable from "./ActivityLogTable";

const ActivityLog: React.FC = () => {

    return (
        <div>
         

     <ActivityDashboard />
     <ActivityTimeline />
     <ActivityLogTable />
        </div>
    );
};

export default ActivityLog;